/*
 * Action Types
 */
export enum IntegrationFenceTypes {
  LIST_INTEGRATION_FENCES_REQUEST = '@integrationFence/LIST_INTEGRATION_FENCES_REQUEST',
  LIST_INTEGRATION_FENCES_SUCCESS = '@integrationFence/LIST_INTEGRATION_FENCES_SUCCESS',
  LIST_INTEGRATION_FENCES_FAILURE = '@integrationFence/LIST_INTEGRATION_FENCES_FAILURE',

  GET_INTEGRATION_FENCE_REQUEST = '@integrationFence/GET_INTEGRATION_FENCE_REQUEST',
  GET_INTEGRATION_FENCE_SUCCESS = '@integrationFence/GET_INTEGRATION_FENCE_SUCCESS',
  GET_INTEGRATION_FENCE_FAILURE = '@integrationFence/GET_INTEGRATION_FENCE_FAILURE',

  CREATE_INTEGRATION_FENCE_REQUEST = '@integrationFence/CREATE_INTEGRATION_FENCE_REQUEST',
  CREATE_INTEGRATION_FENCE_SUCCESS = '@integrationFence/CREATE_INTEGRATION_FENCE_SUCCESS',
  CREATE_INTEGRATION_FENCE_FAILURE = '@integrationFence/CREATE_INTEGRATION_FENCE_FAILURE',

  UPDATE_INTEGRATION_FENCE_REQUEST = '@integrationFence/UPDATE_INTEGRATION_FENCE_REQUEST',
  UPDATE_INTEGRATION_FENCE_SUCCESS = '@integrationFence/UPDATE_INTEGRATION_FENCE_SUCCESS',
  UPDATE_INTEGRATION_FENCE_FAILURE = '@integrationFence/UPDATE_INTEGRATION_FENCE_FAILURE',

  DELETE_INTEGRATION_FENCE_REQUEST = '@integrationFence/DELETE_INTEGRATION_FENCE_REQUEST',
  DELETE_INTEGRATION_FENCE_SUCCESS = '@integrationFence/DELETE_INTEGRATION_FENCE_SUCCESS',
  DELETE_INTEGRATION_FENCE_FAILURE = '@integrationFence/DELETE_INTEGRATION_FENCE_FAILURE',
}

/*
 * Data types
 */

export interface BoundsInterface {
  lat: number;
  lng: number;
}

export interface IntegrationFenceInterface {
  id: string;
  name: string;
  bounds: BoundsInterface[];
  integration: boolean | null;
  createdAt: Date | null;
  updatedAt: Date | null;
  transportOperatorId?: string;
}

/*
 * State type
 */
export interface IntegrationFenceState {
  readonly integrationFenceList: IntegrationFenceInterface[];
  readonly integrationFenceData: IntegrationFenceInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
